import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, switchMap, catchError } from 'rxjs/operators';
import { FriendService } from '../search-friend.service';
import { UserAccount } from '../user-account';
import { of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {} from '@angular/common/http';
import { ConnectedPeopleComponent } from '../connected-people/connected-people.component';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '../app.component';
import { provideHttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    // Other providers here
  ],
}).catch((err) => console.error(err));

@Component({
  selector: 'app-social-zone',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,

    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    //HttpClientModule,
    ReactiveFormsModule,
    ConnectedPeopleComponent,
    TranslateModule,
  ],
  providers: [FriendService],
  template: `
    <div class="social-zone-container">
      <mat-form-field class="search-field">
        <mat-label>{{ 'social-zone.FIND_FRIEND' | translate }}</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          [placeholder]="'social-zone.SEARCH_PLACEHOLDER' | translate"
        />
      </mat-form-field>
      <div *ngIf="results.length" class="results-container">
        <ul class="user-list">
          <li *ngFor="let user of results" class="user-item">
            <div class="action-buttons">
              <button
                *ngIf="user.friendStatus === 0"
                (click)="onAddFriend(user)"
                class="add-friend-btn"
              >
                {{ 'social-zone.ADD_FRIEND_BUTTON' | translate }}
              </button>
              <span *ngIf="user.friendStatus === 1" class="status pending">
                {{ 'social-zone.STATUS_PENDING' | translate }}
              </span>
              <span *ngIf="user.friendStatus === 2" class="status friend">
                {{ 'social-zone.STATUS_FRIEND' | translate }}
              </span>
              <span *ngIf="user.friendStatus === 3" class="status following">
                {{ 'social-zone.STATUS_FOLLOWING' | translate }}
              </span>
            </div>
            <span class="user-name">{{ user.name }} {{ user.last_name }}</span>
          </li>
        </ul>
      </div>
      <div
        *ngIf="searchControl.value && results.length === 0"
        class="no-results"
      >
        <p>{{ 'social-zone.NO_RESULTS' | translate }}</p>
      </div>
      <div>
        <app-connected-people></app-connected-people>
      </div>
    </div>
  `,
  styleUrls: ['./social-zone.component.css'],
})
export class SocialZoneComponent {
  searchControl = new FormControl();
  results: UserAccount[] = [];

  constructor(private friendService: FriendService) {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300), // Wait 300ms after the last keystroke before triggering the search
        switchMap((value) =>
          this.friendService.searchUsers(value).pipe(
            catchError((error) => {
              console.error('Search error:', error);
              return of([]); // Return an empty array on error
            }),
          ),
        ),
      )
      .subscribe((results) => {
        console.log('Search results:', results);
        this.results = results;
      });
  }

  onAddFriend(user: UserAccount): void {
    console.log(
      `Add friend clicked for user: ${user.name} ${user.last_name} ${user.friendStatus}`,
    );
    this.friendService.addFriend(user.id).subscribe({
      next: (response) => {
        console.log('Friend request sent:', response);
        user.friendStatus = 1; // Update the status to "Pending" on successful request
      },
      error: (error) => {
        console.error('Failed to send friend request:', error);
      },
    });
  }
}
